// Storage abstraction layer
export const STORAGE_KEYS = {
  USER: "USER",
  ACCESS_TOKEN: "ACCESS_TOKEN",
  USER_ID: "USER_ID",
} as const;

export const set = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.error("Failed to set storage item:", e);
  }
};

export const get = (key: string, defaultValue?: string): string => {
  try {
    return localStorage.getItem(key) || defaultValue || "";
  } catch (e) {
    console.error("Failed to get storage item:", e);
    return defaultValue || "";
  }
};

export const remove = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.error("Failed to remove storage item:", e);
  }
};

export const clearAll = (): void => {
  try {
    localStorage.clear();
  } catch (e) {
    console.error("Failed to clear storage:", e);
  }
};

export default { set, get, remove, clearAll, STORAGE_KEYS };
